import * as React from 'react';
const MigliorareMemoriaEConcentrazioneIcon = ({
  primaryColor,
  secondaryColor,
  width,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-1,.prefix__cls-2{stroke:${secondaryColor ||
        '#ffcf38'};fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}.prefix__cls-2{stroke:${primaryColor ||
        '#282828'}}`}</style>
    </defs>
    <path
      d="M100 45.42v13.87M85.59 56.21l2.28 5.49M65.22 76.58l9.96 4.13M67.77 58.76l12.11 12.11M56.41 90.99h15.85M114.41 56.21l-2.28 5.49M134.78 76.58l-9.96 4.13M132.23 58.76l-12.11 12.11M143.59 90.99h-15.85"
      className="prefix__cls-1"
    />
    <path
      d="M114.5 120.2c6.62 4.01 9.28-3.21 9.28-3.21l-6.78-6.75s-1.68-7.86-1.89-8.98c-.4-2.19-1.87-4.23-3.72-5.11s-7.63-3.18-11.39-3.18M100 92.97c4.54 0 7.93-3.8 7.93-8.49v-2.83c0-4.69-3.39-8.49-7.93-8.49s-7.93 3.8-7.93 8.49v2.83c0 4.69 3.39 8.49 7.93 8.49M85.75 134.58h-3.52c-3.68 0-4.73-1.82-5.6-3.79-.85-1.92-.41-4.5 1.83-5.96 3.76-2.45 12.63-8.31 12.63-8.31l1.51-9.48"
      className="prefix__cls-2"
    />
    <path
      d="m105.3 124.03-10.95 1.68c-5.26.83-4.96 8.87.74 8.87h22.68c3.68 0 4.73-1.82 5.6-3.79.85-1.92.41-4.5-1.83-5.96-3.76-2.45-12.63-8.31-12.63-8.31l-1.51-9.48M85.5 120.2c-6.62 4.01-9.28-3.21-9.28-3.21l6.78-6.75s1.68-7.86 1.89-8.98c.4-2.19 1.87-4.23 3.72-5.11s7.63-3.18 11.39-3.18"
      className="prefix__cls-2"
    />
  </svg>
);
export default MigliorareMemoriaEConcentrazioneIcon;
